export function isSupported(): boolean {
  return typeof window !== 'undefined' && 'speechSynthesis' in window;
}

export function speak(text: string): void {
  if (!isSupported() || !text) return;
  try {
    window.speechSynthesis.cancel();
    const u = new SpeechSynthesisUtterance(text);
    u.lang = /^[a-zA-Z0-9\s]+$/.test(text) ? 'en-US' : 'zh-TW';
    u.rate = 1;
    window.speechSynthesis.speak(u);
  } catch {
    /* noop */
  }
}
